import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import * as api from "../api";
 
function LoginPage() {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
 
  const handleLogin = async (e) => {
    e.preventDefault();
    setError("");
    setIsLoading(true);
    try {
      await api.loginUser(username, password);
      localStorage.setItem("isAuthenticated", "true");
      navigate("/dashboard");
    } catch (err) {
      // Adicionada a chave que faltava
      setError("Utilizador ou palavra-passe inválidos.");
      console.error("Erro no login:", err);
    } finally {
      setIsLoading(false);
    }
  };
 
  return (
    // ATUALIZADO: Adicionado o estilo para a imagem de fundo
    <div
      className="flex items-center justify-center min-h-screen font-sans p-4"
      style={{
        backgroundImage: "url('/fundo.png')",
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
      }}
    >
      {/* ATUALIZADO: Largura máxima do card diminuída */}
      <div className="relative w-full max-w-xs bg-white rounded-2xl shadow-lg transform transition-all hover:shadow-2xl overflow-hidden">
        {/* Cabeçalho com a imagem acima do texto */}
        {/* ATUALIZADO: Padding interno diminuído */}
        <div className="relative text-center p-8">
          {/* Imagem como um elemento separado */}
          <img
            src="/11.png"
            alt="TBM Logo"
            // ATUALIZADO: Altura do logo diminuída
            className="mx-auto h-[170px] w-auto mb-4"
          />
 
          <div className="relative z-10">
            {/* ATUALIZADO: Tamanho da fonte do título diminuído */}
            <p className="text-2xl font-semibold text-blue-700 tracking-widest uppercase">
              TBM QRCODE
            </p>
          </div>
        </div>
 
        {/* Formulário */}
        {/* ATUALIZADO: Padding interno diminuído */}
        <div className="p-6 pt-0">
          {/* ATUALIZADO: Espaçamento entre os elementos do formulário diminuído */}
          <form onSubmit={handleLogin} className="space-y-4">
            <div>
              <label
                htmlFor="username"
                className="block text-sm font-medium text-gray-700 mb-1"
              >
                Usuário
              </label>
              <input
                type="text"
                id="username"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                // ATUALIZADO: Padding do input diminuído
                className="mt-1 w-full p-2.5 bg-gray-50 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:outline-none transition"
                required
                placeholder=""
              />
            </div>
            <div>
              <label
                htmlFor="password"
                className="block text-sm font-medium text-gray-700 mb-1"
              >
                Senha
              </label>
              <input
                type="password"
                id="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                // ATUALIZADO: Padding do input diminuído
                className="mt-1 w-full p-2.5 bg-gray-50 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:outline-none transition"
                required
                placeholder=""
              />
            </div>
            {error && (
              <p className="text-red-500 text-xs text-center">{error}</p>
            )}
            <button
              type="submit"
              // ATUALIZADO: Padding do botão diminuído
              className="w-full bg-blue-600 text-white font-bold py-2.5 rounded-lg hover:bg-blue-700 focus:outline-none focus:ring-4 focus:ring-blue-300 transform hover:-translate-y-1 transition-all duration-300 shadow-md hover:shadow-lg disabled:opacity-50"
              disabled={isLoading}
            >
              {isLoading ? "A entrar..." : "Entrar"}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
 
export default LoginPage;